import React from "react";
import { useNavigate } from "react-router-dom";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi2";
import {
  ProductMasterIcon,
  CompanyManagementIcon,
  InwardManagementIcon,
  OutwardManagementIcon,
  ReturnManagementIcon,
  PutawayManagementIcon,
  BinManagementIcon,
  ReportsManagementIcon,
} from "../../assets/sidebarIcon/icons";
import JDLogo from "../../assets/JDLogo.png";
import JDSmallLogo from "../../assets/jdSmallLogo.png";

export function Sidebar({
  isSidebarOpen,
  setIsSidebarOpen,
  isMobile = false,
  hoveredItem,
  setHoveredItem,
  tooltipPos,
  setTooltipPos,
  buttonRefs,
  navItems,
  location,
}) {
  const navigate = useNavigate();
  return (
    <aside
      className={`fixed md:relative top-0 left-0 h-full md:h-auto z-30 md:z-auto ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'} transition-transform duration-300 ease-in-out md:ml-5 md:mt-5 md:mb-5`}
      style={{
        backgroundColor: "#ffffff",
        border: "0.5px solid #F5EFEB66",
        borderRadius: "28px",
        boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
        display: "flex",
        flexDirection: "column",
        flexShrink: 0,
        marginLeft: isMobile ? "0" : "20px",
        marginTop: isMobile ? "0" : "20px",
        marginBottom: isMobile ? "0" : "20px",
        transition: "width 0.3s ease",
        position: isMobile ? "fixed" : "relative",
        zIndex: 30,
        overflow: isMobile ? "hidden" : "visible",
        width: isMobile ? "280px" : isSidebarOpen ? '280px' : '95px',
        maxWidth: isMobile ? "80vw" : "none",
      }}
    >
      {/* Logo */}
      <div
        style={{
          padding: "0.75rem 1rem",
          borderBottom: "1px solid #e5e7eb",
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: isSidebarOpen ? "space-between" : "space-between",
          gap: "0.5rem",
          flexDirection: "row",
          position: "relative",
        }}
      >
        {isSidebarOpen ? (
          <img
            src={JDLogo}
            alt="JustDeliveries"
            style={{ width: "150px", height: "22px", display: "block" }}
          />
        ) : (
          <img
            src={JDSmallLogo}
            alt="JustDeliveries"
            style={{
              width: "40px",
              height: "40px",
              display: "block",
              flexShrink: 0,
            }}
          />
        )}
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          style={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: "0.25rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "0.25rem",
            transition: "background-color 0.2s",
            flexShrink: 0,
            marginLeft: "auto",
            marginRight: 0,
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#f3f4f6";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "transparent";
          }}
        >
          {isSidebarOpen ? (
            <HiChevronLeft style={{ fontSize: "1.25rem", color: "#4b5563" }} />
          ) : (
            <HiChevronRight style={{ fontSize: "1.25rem", color: "#4b5563" }} />
          )}
        </button>
      </div>
      {/* Navigation */}
      <nav
        style={{
          flex: 1,
          padding: "0.5rem 0.75rem",
          overflowY: "auto",
          overflowX: "visible",
          display: "flex",
          flexDirection: "column",
          gap: "2px",
          position: "relative",
          zIndex: 1,
        }}
      >
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          const customIcon =
            item.label === "Product Master" ? (
              <ProductMasterIcon size={20} color="#808080" />
            ) : item.label === "Company Management" ? (
              <CompanyManagementIcon size={20} color="#808080" />
            ) : item.label === "Inward Management" ? (
              <InwardManagementIcon size={20} color="#808080" />
            ) : item.label === "Outward Management" ? (
              <OutwardManagementIcon size={20} color="#808080" />
            ) : item.id === "returns" ? (
              <ReturnManagementIcon size={20} color="#808080" />
            ) : item.id === "putaway" ? (
              <PutawayManagementIcon size={20} color="#808080" />
            ) : item.id === "bins" ? (
              <BinManagementIcon size={20} color="#808080" />
            ) : item.id === "reports" ? (
              <ReportsManagementIcon size={20} color="#808080" />
            ) : null;
          return (
            <div
              key={item.id}
              style={{
                position: "relative",
                zIndex: hoveredItem === item.id ? 50 : 1,
                overflow: "visible",
              }}
              onMouseEnter={() => setHoveredItem(item.id)}
              onMouseLeave={() => setHoveredItem(null)}
            >
              <button
                ref={(el) => (buttonRefs.current[item.id] = el)}
                onClick={() => navigate(item.path)}
                style={{
                  width: "100%",
                  background: isActive ? "#FFFFFF" : "transparent",
                  color: isActive ? "#188742" : "#667085",
                  border: "none",
                  borderRadius: "12px",
                  height: "44px",
                  paddingLeft: 14,
                  paddingRight: 14,
                  paddingTop: 0,
                  paddingBottom: 0,
                  // display: "flex",
                  // alignItems: "center",
                  // gap: isSidebarOpen ? 10 : 0,
                  display: "flex",
alignItems: "center",
justifyContent: isSidebarOpen ? "flex-start" : "center",
gap: isSidebarOpen ? 10 : 0,
                  fontWeight: isActive ? 600 : 500,
                  fontSize: "0.9150rem",
                  cursor: "pointer",
                  marginBottom: "0",
                  position: "relative",
                  transition: "background 0.2s, color 0.2s",
                  outline: "none",
                  boxShadow: isActive
                    ? "0 4px 14px rgba(16,24,40,0.06)"
                    : "none",
                }}
                onMouseEnter={(e) => {
                  if (!isActive) e.currentTarget.style.background = "#F6F7FA";
                }}
                onMouseLeave={(e) => {
                  if (!isActive) e.currentTarget.style.background = "transparent";
                }}
              >
                {isActive && (
                  <span
                    style={{
                      position: "absolute",
                      left: 0,
                      top: 4,
                      bottom: 4,
                      width: 4,
                      backgroundColor: "#188742",
                      borderRadius: "0 6px 6px 0",
                    }}
                    aria-hidden
                  />
                )}
                {customIcon ? (
                  <span
                    style={{
                      flexShrink: 0,
                      marginRight: isSidebarOpen ? 12 : 0,
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {customIcon}
                  </span>
                ) : (
                  <item.icon
                    size={item.id === "dashboard" ? 22 : 18}
                    strokeWidth={1.75}
                    style={{
                      flexShrink: 0,
                      color: isActive ? "#188742" : "#667085",
                      marginRight: isSidebarOpen ? 12 : 0,
                    }}
                  />
                )}
                {isSidebarOpen && (
                  <span style={{ flex: 1, textAlign: "left" }}>
                    {item.label}
                  </span>
                )}
              </button>
            </div>
          );
        })}
      </nav>
    </aside>
  );
}
